module.exports = __webpack_public_path__ + "img/deco_cloud_3.63d9fc43.png";